"use client"

import { useSyncExternalStore } from "react"
import { useTheme } from "next-themes"
import { Button } from "@/components/ui/button"
import { Monitor, Moon, Sun } from "lucide-react"

export function ThemeModeToggle() {
  const { theme, setTheme } = useTheme()
  const mounted = useSyncExternalStore(
    () => () => {},
    () => true,
    () => false
  )

  if (!mounted) {
    return <div className="h-8" />
  }

  return (
    <div className="flex items-center gap-1">
      <Button
        type="button"
        size="sm"
        variant={theme === "light" ? "secondary" : "ghost"}
        className={`h-8 w-8 p-0 ${
          theme === "light"
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
        onClick={() => setTheme("light")}
        aria-label="Tema chiaro"
        title="Tema chiaro"
      >
        <Sun className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant={theme === "dark" ? "secondary" : "ghost"}
        className={`h-8 w-8 p-0 ${
          theme === "dark"
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
        onClick={() => setTheme("dark")}
        aria-label="Tema scuro"
        title="Tema scuro"
      >
        <Moon className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        size="sm"
        variant={theme === "system" ? "secondary" : "ghost"}
        className={`h-8 w-8 p-0 ${
          theme === "system"
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
        onClick={() => setTheme("system")}
        aria-label="Tema automatico"
        title="Tema automatico"
      >
        <Monitor className="h-4 w-4" />
      </Button>
    </div>
  )
}
